"use strict";

var intersectionByL = require('../Lazy/intersectionByL.js');

var curry2 = require('./curry2.js');

var takeAll = require('./takeAll.js');

module.exports = curry2(function intersectionBy(f, b, a) {
  return takeAll(intersectionByL(f, b, a));
});